import country from "country-list-js";
import {AgencyProps, WindowedAgencyProps} from "../../api/model/agency";
import {UserProps, WindowedUserProps} from "../../api/model/user";

const countryCodes = require('country-codes-list')
export type CountryAlpha2Props = { [key: string]: string }
export const allCountryNamesAlpha2CountryCode: CountryAlpha2Props = countryCodes.customList('countryCode', '{countryNameEn}')
export const allInternationalPhonePrefixesFormattedForDropdownAlpha2CountryCode: CountryAlpha2Props = countryCodes.customList('countryCode', '[{countryCode}] {countryNameEn}: +{countryCallingCode}')
export const allInternationalPhonePrefixesFormattedForDataGridAlpha2CountryCode: CountryAlpha2Props = countryCodes.customList('countryCode', '+{countryCallingCode}')
export const allCountryNames: string[] = country.names();

export interface CountryProps {
    name: string,
    id: number
}

export const getPossibleAgenciesToMoveUserTo = (
    agencies: (AgencyProps | WindowedAgencyProps)[],
    user: UserProps | WindowedUserProps | null
) =>
    agencies
        .filter(agency => !user?.agencyIds.includes(agency.id))
        .map((filteredAgency, index) => ({
            label: filteredAgency.name,
            value: index,
            id: filteredAgency.id,
        }))
